import ThrottleTransition from "./purchase/throttle-transition.svg";
import YourNextChapter from "./purchase/your-next-chapter-image.svg";
import CarPlusShield from "./car-shield.png";

export { ThrottleTransition, YourNextChapter, CarPlusShield };
